export const WEBSITE_API =
  'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev';

export async function oauthLogin(provider, token) {
  const response = await fetch(`${WEBSITE_API}/oauth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ provider, token })
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'Sign-in failed');
  }
  return data;
}
